export enum GuestGroup {
  Golfers = "golfers",
  Colleagues = "colleagues",
  Family = "family",
  Friends = "friends",
  Other = "other",
}

export const guestGroups: Record<GuestGroup, { label: string; colour: string; colourName: string }> = {
  [GuestGroup.Golfers]: { label: "Golfers", colour: "#83b599", colourName: "Green" },
  [GuestGroup.Colleagues]: { label: "Colleagues", colour: "#9abce0", colourName: "Blue" },
  [GuestGroup.Family]: { label: "Family", colour: "#e7b1c3", colourName: "Dusty pink" },
  [GuestGroup.Friends]: { label: "Friends", colour: "#d995ab", colourName: "Rose" },
  [GuestGroup.Other]: { label: "Other", colour: "#d7bf86", colourName: "Gold" },
};

export function isGuestGroup(value: unknown): value is GuestGroup {
  return typeof value === "string" && Object.values(GuestGroup).includes(value as GuestGroup);
}
